import type { RasterLayerSource } from '@/hooks/useDatasets';
import { releaseTilesPath } from './releaseTiles';
import { TileLayer } from '@deck.gl/geo-layers';
import { BitmapLayer } from '@deck.gl/layers';
import { GL } from '@luma.gl/constants';
import type { LayerConfig } from './types';
import { DEFAULT_TREE_COVER_MIN_ZOOM, LayerType } from './types';
import { getGeoBoundingBox } from '@/views/map/utils';

export const getInspectLayer = (
  source: RasterLayerSource,
  config: LayerConfig,
  minZoom = DEFAULT_TREE_COVER_MIN_ZOOM,
  maxZoom = 18
) => {
  return new TileLayer({
    id: LayerType[LayerType.distance_bucket],
    ...config,
    data: `${releaseTilesPath(source, 'png')}?pixel_selection=first&tilesize=512`,
    loadOptions: {
      fetch: {
        credentials: 'include',
      },
    },
    minZoom,
    maxZoom,
    opacity: 0,
    pickable: true,
    renderSubLayers: (props) => {
      if (props.data === null) {
        return null;
      }
      const boundingBox = getGeoBoundingBox(props);
      if (!boundingBox) {
        return null;
      }
      const { west, south, east, north } = boundingBox;

      return new BitmapLayer({
        id: props.id,
        image: props.data,
        bounds: [west, south, east, north],
        textureParameters: {
          [GL.TEXTURE_MIN_FILTER]: GL.NEAREST,
          [GL.TEXTURE_MAG_FILTER]: GL.NEAREST,
        },
        transparentColor: [0, 0, 0, 0],
        pickable: true,
        highlightColor: props.highlightColor,
        opacity: props.opacity,
        visible: props.visible,
      });
    },
  });
};
